module.exports = __webpack_public_path__ + "img/businessman-workig-e-usando-calculadora-com-laptop-na-mesa_34152-1467.f39babcd.jpg";